/** Round to 2 decimal places (avoids 439.9999999999 display bugs) */

function round2(n) {

  return parseFloat((Number(n) || 0).toFixed(2));

}



/** Round quantity to 4 decimals */

function roundQty(n) {

  return parseFloat((Number(n) || 0).toFixed(4));

}



/** Store rate with up to 4 decimals (display can still show 2) */

function roundRate(n) {

  return parseFloat((Number(n) || 0).toFixed(4));

}



function isKachhaBillType(billType) {

  return billType === "kachuBill" || billType === "kachuBillGstIncl" || billType === "delivery";

}



function lineDivisor(quantity, gstRate, billType) {

  const q = Number(quantity) || 0;

  const g = Number(gstRate) || 0;

  const isKachha = isKachhaBillType(billType);

  if (isKachha || billType === "withTax" || billType === "withTaxIgst") {

    return q;

  }

  return q * (1 + g / 100);

}



/** Line total (amount) for one bill row */

export function getLineTotal({ rate = 0, quantity = 0, gstRate = 0, billType = "withoutTax" }) {

  const r = Number(rate) || 0;

  const q = Number(quantity) || 0;

  const g = Number(gstRate) || 0;

  const isKachha = isKachhaBillType(billType);

  if (isKachha || billType === "withTax" || billType === "withTaxIgst") {

    return round2(r * q);

  }

  return round2(r * q * (1 + g / 100));

}



/** Quantity from desired line amount and unit rate */

export function getQuantityFromAmount({ amount = 0, rate = 0, gstRate = 0, billType = "withoutTax" }) {

  const r = Number(rate) || 0;

  const a = Number(amount) || 0;

  if (r <= 0 || a <= 0) return 0;

  const g = Number(gstRate) || 0;

  const isKachha = isKachhaBillType(billType);

  const perUnit =

    isKachha || billType === "withTax" || billType === "withTaxIgst"

      ? r

      : r * (1 + g / 100);

  return roundQty(a / perUnit);

}



/**

 * Unit rate from line amount + quantity so line total equals entered amount exactly

 * (e.g. amount 7000 → total shows 7000.00, not 6999.99).

 */

export function getRateFromAmount({ amount = 0, quantity = 0, gstRate = 0, billType = "withoutTax" }) {

  const q = Number(quantity) || 0;

  const target = round2(Number(amount) || 0);

  if (q <= 0 || target <= 0) return 0;



  const g = Number(gstRate) || 0;

  const divisor = lineDivisor(q, g, billType);

  if (divisor <= 0) return 0;



  const exactRate = target / divisor;

  const lineOpts = { quantity: q, gstRate: g, billType };



  if (getLineTotal({ rate: exactRate, ...lineOpts }) === target) {

    return roundRate(exactRate);

  }



  let bestRate = roundRate(exactRate);

  let bestDiff = Math.abs(getLineTotal({ rate: bestRate, ...lineOpts }) - target);



  for (let delta = -100; delta <= 100; delta++) {

    const candidate = roundRate(exactRate + delta * 0.0001);

    if (candidate < 0) continue;

    const line = getLineTotal({ rate: candidate, ...lineOpts });

    if (line === target) return candidate;

    const diff = Math.abs(line - target);

    if (diff < bestDiff) {

      bestDiff = diff;

      bestRate = candidate;

    }

  }



  return bestRate;

}



/** Sum of all line totals for bill items */

export function sumBillLineTotals(items, billType = "withoutTax") {

  const isKachha = isKachhaBillType(billType);

  return round2(

    (items || []).reduce(

      (sum, item) =>

        sum +

        getLineTotal({

          rate: item.rate,

          quantity: item.quantity,

          gstRate: isKachha ? 0 : item.gstRate || 0,

          billType,

        }),

      0

    )

  );

}



/** Adjust item rates so bill total matches entered grand total exactly (quantities unchanged) */

export function applyGrandTotalToItems(items, targetAmount, billType = "withoutTax") {

  if (!items?.length || !(targetAmount > 0)) return items;



  const target = round2(targetAmount);

  const isKachha = isKachhaBillType(billType);



  if (items.length === 1) {

    const item = items[0];

    return [

      {

        ...item,

        rate: getRateFromAmount({

          amount: target,

          quantity: item.quantity,

          gstRate: isKachha ? 0 : item.gstRate || 0,

          billType,

        }),

      },

    ];

  }



  const current = sumBillLineTotals(items, billType);

  if (current <= 0) return items;



  const factor = target / current;

  let updated = items.map((item) => ({

    ...item,

    rate: roundRate((item.rate || 0) * factor),

  }));



  let diff = round2(target - sumBillLineTotals(updated, billType));

  if (diff !== 0) {

    const idx = updated.length - 1;

    const item = updated[idx];

    const currentLine = getLineTotal({

      rate: item.rate,

      quantity: item.quantity,

      gstRate: isKachha ? 0 : item.gstRate || 0,

      billType,

    });

    updated[idx] = {

      ...item,

      rate: getRateFromAmount({

        amount: round2(currentLine + diff),

        quantity: item.quantity,

        gstRate: isKachha ? 0 : item.gstRate || 0,

        billType,

      }),

    };

  }



  return updated;

}


